import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { order } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const orderSlice = createSlice({
    name: order,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },

});


export const { setNewEntryMode, setDetailParams, resetDetailParams } = orderSlice.actions;
export default orderSlice.reducer;
